const isTokenExpired = (userToken) => {
    if (!userToken) return true;

    const tokenPayload = userToken.split('.')[1];
    const {exp} = JSON.parse(window.atob(tokenPayload));

    if (!exp) return true;
    return Date.now() >= exp * 1000;
};

export const getToken = () => {
    const tokenString = localStorage.getItem('token');
    const userToken = JSON.parse(tokenString)?.token;
    
    if (isTokenExpired(userToken)) {
        localStorage.removeItem("token");
        return undefined;
    }
    return userToken;
};

export const saveToken = (tokenData) => {
    if (!tokenData) {
        localStorage.removeItem("token");
    } else if (!isTokenExpired(tokenData?.token)) {
        localStorage.setItem("token", JSON.stringify(tokenData));
        location.reload();
    }
};
